import { registerVPortal } from "../main/utils/vportal.js";

(function () {
	'use strict';

	function pad2(n) {
		return n < 10 ? '0' + n : '' + n;
	}

	function initBannerSwiper(retry) {
		retry = retry || 0;
		if (typeof window.Swiper === 'undefined') {

			if (retry < 20) {
				setTimeout(function () { initBannerSwiper(retry + 1); }, 100);
			}
			return;
		}

		var el = document.querySelector('.f2-banner-swiper');
		if (!el || el.swiper) return;

		var counterEl = document.querySelector('#x5-frame2 .f2-banner__cur');

		// Tổng slide phải ghi bằng JS, không hardcode: banner do CMS cấp nên số lượng thay đổi.
		// Sửa thẳng text node "/04" thay vì thêm element mới, vì HTML production do new-mainsite
		// render (component/banner/wp-x5-home-banner.html.twig) — markup bên đó mình không đụng được.
		// Đếm slide TRƯỚC khi new Swiper: loop:true sẽ nhân bản slide vào wrapper, đếm sau là ra số ảo.
		var slideTotal = el.querySelectorAll('.swiper-slide').length;
		var numEl = document.querySelector('#x5-frame2 .f2-banner__num');
		if (numEl) {
			// duyệt childNodes tìm text node chứa "/" — không dùng lastChild vì server Twig có thể
			// sinh thêm whitespace phía sau làm lastChild trỏ trúng node rỗng
			for (var i = 0; i < numEl.childNodes.length; i++) {
				var node = numEl.childNodes[i];
				if (node.nodeType === 3 && node.nodeValue.indexOf('/') !== -1) {
					node.nodeValue = '/' + pad2(slideTotal);
					break;
				}
			}
		}

		function syncCounter(sw) {
			if (counterEl) counterEl.textContent = pad2((sw.realIndex || 0) + 1);
		}

		var bannerSwiper = new window.Swiper('.f2-banner-swiper', {
			direction: 'horizontal',
			loop: true,
			speed: 500,
			allowTouchMove: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '#x5-frame2 .f2-banner__dots',
				clickable: true,
				bulletClass: 'f2-bullet',
				bulletActiveClass: 'f2-bullet--active',
			},
			on: {
				init: function () { syncCounter(this); },
				slideChange: function () { syncCounter(this); },
			},
		});

		var prev = document.querySelector('#x5-frame2 .f2-banner__prev');
		var next = document.querySelector('#x5-frame2 .f2-banner__next');
		if (prev) prev.addEventListener('click', function () { bannerSwiper.slidePrev(); });
		if (next) next.addEventListener('click', function () { bannerSwiper.slideNext(); });
	}

	function initNews(retry) {
		retry = retry || 0;

		if (!document.querySelector('.f2-news')) return;
		var $ = window.jQuery || window.$;
		if (!$) {

			if (retry < 20) setTimeout(function () { initNews(retry + 1); }, 100);
			return;
		}

		registerVPortal($);

		$('.news').each(function () {
			var postsTag = '#' + $(this).attr('id');
			$(postsTag).vPortal({
				container: postsTag,
				el: {
					tabContainer: '.f2-news__tab',
					resultContainer: '.f2-news__list',
					viewAll: '.f2-news__more',
				},
				paginationOptions: {},
			});

			var $active = $(postsTag + ' .f2-news__tab.active');
			if ($active.length && $active.data('block-name')) $active.trigger('click');
		});
	}

	window.addEventListener('load', function () {
		initBannerSwiper();
		initNews();
	});
})();
